import { colors } from "shared/styles/constants";
import styled from "styled-components";

export const InfoInnerTitleWrapper = styled.div`
  @media print {
    padding: 14px;
    padding-bottom: 0;
  }
`;

export const StyledInfoComponentWrapper = styled.div`
  @media print {
    > * {
      display: block;
      > * {
        background: ${colors.grey6};
      }
    }
  }
`;

export const StyledImageGridWrapper = styled.div`
  @media print {
    page-break-inside: avoid;
  }
`;
